<template>

    <div id="trainingClassCourseware">
        <v-card>
            <v-toolbar flat color="grey lighten-4" light>
                <v-autocomplete
                        v-model="searchedManual"
                        :items="manuals"
                        item-text="title"
                        return-object
                >
                    <template v-slot:append-outer>
                        <v-btn @click="updateCourseManual(searchedManual)">Attach Manual</v-btn>
                    </template>
                </v-autocomplete>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col
                            v-for="manual in model.manuals" :key="manual.id"
                            cols="3"
                    >

                        <v-card>

                            <v-card-title>
                                <v-badge
                                        color="blue"
                                        :content="'v' + manual.version"
                                        v-if="manual.version"
                                >
                                    {{manual.title}}
                                </v-badge>
                                <template v-else> {{manual.title}}</template>

                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Author:</h4>{{manual.author}}
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>Supplier:</h4>
                                        {{manual.supplier}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Pages:</h4>
                                        {{manual.pageCount}}
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>File Size:</h4>
                                        {{manual.fileSize | prettyBytes}}
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn :href="manual.url">Download</v-btn>
                                <v-spacer/>
                                <v-btn
                                        color="error"
                                        @click="updateCourseManual(manual, true)"
                                        dark
                                >
                                    <v-icon left>mdi-delete</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>


    </div>

</template>


<script>

    import TRAINING_CLASS_UPDATE from "../../graphql/TrainingClassUpdate.gql";
    import MANUALS from "../../graphql/ManualAllActive.gql";

    export default {
        props: {
            model: Object
        },
        data() {
            return {
                searchedManual: null,
                updating: false,
            }
        },
        watch: {
            updating(value) {
                this.$emit('updating', value);
                this.$store.dispatch('notification/loading', value)
            }
        },
        apollo: {
            manuals: {
                query: MANUALS,
                update: data => data.activeManuals
            }
        },
        methods: {
            updateCourseManual(manual, remove = false) {
                this.updating = true

                let change = {connect: [manual.id]}
                if (remove) {
                    change = {disconnect: [manual.id]}
                }

                this.$apollo.mutate({
                    mutation: TRAINING_CLASS_UPDATE,
                    variables: {
                        trainingClass: {
                            id: this.model.id,
                            manuals: change
                        }
                    }
                }).then(() => {
                    this.updating = false
                    this.$emit('saved')
                    if (remove) {
                        this.$store.dispatch('notification/addSuccess', 'Manual removed successfully')
                    }else{
                        this.$store.dispatch('notification/addSuccess', 'Manual attached successfully')
                    }
                }).catch((error) => {
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },
        }
    }


</script>